import React from 'react';
import { CognocracyHero } from '../../components/cognocracy/CognocracyHero';
import { CognocracyPurpose } from '../../components/cognocracy/CognocracyPurpose';
import { CognocracyFramework } from '../../components/cognocracy/CognocracyFramework';
import { CognocracyPlatform } from '../../components/cognocracy/CognocracyPlatform';
import { CognocracyResearch } from '../../components/cognocracy/CognocracyResearch';
import { CognocracyClosing } from '../../components/cognocracy/CognocracyClosing';
export function CognocracyPage() {
  return <>
      <CognocracyHero data-id="element-3384" data-mp="129z96npzln4g" />
      <CognocracyPurpose data-id="element-3385" data-mp="1h0yftt79i1le" />
      <CognocracyFramework data-id="element-3386" data-mp="1h185tgsb48r3" />
      <CognocracyPlatform data-id="element-3387" data-mp="1h2j9zhpnziiq" />
      <CognocracyResearch data-id="element-3388" data-mp="1h2ro1cxiwtvi" />
      <CognocracyClosing data-id="element-3389" data-mp="1c9q58tu74a6n" />
    </>;
}